(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["philips-home-renueva"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('ph-home-renueva')) return;
  class PhilipsHomeRenueva extends HTMLElement {
    connectedCallback() {
      if (this.phController) return;
      this.phController = new AbortController();
      const signal = this.phController.signal;
      this.addEventListener('change', (event) => this.onVariant(event), { signal });
      this.addEventListener('submit', (event) => this.onSubmit(event), { signal });
      this.addEventListener('click', (event) => this.onClick(event), { signal });
      this.tick();
      if (this.querySelector('[data-countdown]')) this.phClock = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() {
      this.phController?.abort();
      this.phController = null;
      clearInterval(this.phClock);
    }
    tick() {
      const clock = this.querySelector('[data-countdown]');
      if (!clock) return;
      const start = Date.parse(this.dataset.start), end = Date.parse(this.dataset.end), now = Date.now();
      if (!Number.isFinite(start) || !Number.isFinite(end) || end <= start) { clock.hidden = true; return; }
      clock.hidden = false;
      const pending = now < start, ended = now >= end;
      this.dataset.state = ended ? 'ended' : pending ? 'upcoming' : 'active';
      clock.querySelector('[data-clock-label]').textContent = ended ? this.dataset.countdownEnded : pending ? this.dataset.countdownUpcoming : this.dataset.countdownActive;
      clock.querySelector('[data-clock]').hidden = ended;
      if (ended) return;
      const seconds = Math.max(0, Math.floor(((pending ? start : end) - now) / 1000));
      const values = { days: Math.floor(seconds / 86400), hours: Math.floor(seconds / 3600) % 24, minutes: Math.floor(seconds / 60) % 60, seconds: seconds % 60 };
      Object.entries(values).forEach(([key, value]) => { clock.querySelector('[data-' + key + ']').textContent = String(value).padStart(2, '0'); });
    }
    onVariant(event) {
      const select = event.target.closest('[data-variant-select]');
      if (!select) return;
      const option = select.selectedOptions[0], card = select.closest('[data-product]');
      if (!option || !card) return;
      card.querySelector('[data-price]').textContent = option.dataset.price;
      const compare = card.querySelector('[data-compare]'), badge = card.querySelector('[data-sale]');
      compare.textContent = option.dataset.compare;
      compare.hidden = Number(option.dataset.sale) <= 0;
      badge.textContent = '−' + option.dataset.sale + '%'; badge.hidden = Number(option.dataset.sale) <= 0;
      card.querySelector('[data-sku]').textContent = option.dataset.sku;
      const image = card.querySelector('.ph-product-image');
      if (image && option.dataset.image) { image.removeAttribute('srcset'); image.src = option.dataset.image; }
      const button = card.querySelector('[data-add]');
      if (button) { button.disabled = option.dataset.available !== 'true'; button.querySelector('[data-button-text]').textContent = button.disabled ? this.dataset.soldLabel : this.dataset.addLabel; }
      card.querySelectorAll('[data-product-link]').forEach((link) => { const url = new URL(link.href); url.searchParams.set('variant', option.value); link.href = url.toString(); });
      card.querySelector('[data-form-message]').hidden = true;
    }
    async onClick(event) {
      const copy = event.target.closest('[data-copy]');
      if (!copy) return;
      const coupon = copy.closest('.ph-kuesky').querySelector('[data-coupon]').textContent.trim();
      const message = copy.closest('.ph-kuesky').querySelector('[data-copy-status]');
      try {
        await navigator.clipboard.writeText(coupon);
        copy.textContent = this.dataset.copiedLabel;
        message.textContent = this.dataset.copiedLabel + ': ' + coupon;
      } catch (_) {
        message.textContent = coupon;
        const selection = window.getSelection();
        const range = document.createRange(); range.selectNodeContents(copy.closest('.ph-coupon').querySelector('code'));
        selection.removeAllRanges(); selection.addRange(range);
      }
      message.hidden = false;
    }
    async onSubmit(event) {
      const form = event.target.closest('.ph-product-form');
      if (!form) return;
      const button = form.querySelector('[data-add]');
      if (!button) return;
      event.preventDefault();
      if (form.dataset.busy === 'true' || button.disabled) return;
      form.dataset.busy = 'true'; button.disabled = true;
      const label = button.querySelector('[data-button-text]'), message = form.querySelector('[data-form-message]');
      const select = form.querySelector('[data-variant-select]');
      const body = new FormData(form); // Snapshot before disabling the selector.
      if (select) select.disabled = true;
      label.textContent = this.dataset.addingLabel; message.hidden = true;
      form.querySelector('[data-cart-link]').hidden = true;
      const dwell = !!document.querySelector('cart-items-component, cart-drawer-component, cart-icon');
      const dawn = !dwell && document.querySelector('cart-drawer, cart-notification');
      let sections = [];
      if (dwell) sections = Array.from(document.querySelectorAll('cart-items-component[data-section-id]')).map((node) => node.dataset.sectionId);
      else if (dawn?.getSectionsToRender) { sections = dawn.getSectionsToRender().map((item) => item.id); dawn.setActiveElement?.(button); }
      sections = [...new Set(sections)].filter(Boolean).slice(0, 5);
      if (sections.length) body.set('sections', sections.join(','));
      body.set('sections_url', location.pathname + location.search);
      let added = false;
      try {
        const response = await fetch(this.dataset.addUrl, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', body });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : this.dataset.errorLabel);
        added = true;
        message.textContent = this.dataset.addedLabel; message.dataset.error = 'false'; message.hidden = false;
        form.querySelector('[data-cart-link]').hidden = false;
        // Theme UI failure must never retry or report a successful add as failed.
        try {
          if (dwell) {
            this.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: result, sourceId: String(body.get('id')), data: { source: 'product-form-component', itemCount: Number(body.get('quantity') || 1), productId: form.closest('[data-product]').dataset.productId, sections: result.sections || {} } } }));
            if (this.dataset.openCart === 'true') document.querySelector('cart-drawer-component')?.showDialog?.();
          } else if (dawn?.renderContents && result.sections && sections.every((id) => typeof result.sections[id] === 'string')) {
            dawn.classList.remove('is-empty'); dawn.renderContents(result);
          } else {
            const cartResponse = await fetch(this.dataset.cartJson, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
            if (cartResponse.ok) {
              const cart = await cartResponse.json();
              document.querySelectorAll('[data-cart-count], .cart-count-bubble span[aria-hidden="true"]').forEach((node) => { node.textContent = cart.item_count; });
              this.dispatchEvent(new CustomEvent('ph:cart:updated', { bubbles: true, detail: { cart, added: result } }));
            }
          }
        } catch (_) { /* The confirmation and native cart link remain available. */ }
      } catch (error) {
        message.textContent = error instanceof TypeError ? this.dataset.errorLabel : (error.message || this.dataset.errorLabel); message.dataset.error = 'true'; message.hidden = false;
      } finally {
        form.dataset.busy = 'false'; button.disabled = false;
        if (select) select.disabled = false;
        label.textContent = this.dataset.addLabel;
        if (added) this.dispatchEvent(new CustomEvent('ph:product:added', { bubbles: true, detail: { variantId: String(body.get('id')), quantity: Number(body.get('quantity') || 1) } }));
      }
    }
  }
  customElements.define('ph-home-renueva', PhilipsHomeRenueva);
})();

  } catch(e) { console.error(e); }
})();
})();
